import { render, staticRenderFns } from "./residential-lease.vue?vue&type=template&id=310ea4be"
import script from "./residential-lease.vue?vue&type=script&lang=js"
export * from "./residential-lease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports